/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Insert_Button_Aria_LabelInputs */

const en_event_insert_button_aria_label = /** @type {(inputs: Event_Insert_Button_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insert Event`)
};

const fr_event_insert_button_aria_label = /** @type {(inputs: Event_Insert_Button_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserer un evenement`)
};

const de_event_insert_button_aria_label = /** @type {(inputs: Event_Insert_Button_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereignis einfügen`)
};

const it_event_insert_button_aria_label = /** @type {(inputs: Event_Insert_Button_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci evento`)
};

const ru_event_insert_button_aria_label = /** @type {(inputs: Event_Insert_Button_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вставить событие`)
};

const es_event_insert_button_aria_label = /** @type {(inputs: Event_Insert_Button_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insertar evento`)
};

const zh_cn2_event_insert_button_aria_label = /** @type {(inputs: Event_Insert_Button_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`插入事件`)
};

const ja_event_insert_button_aria_label = /** @type {(inputs: Event_Insert_Button_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントを挿入`)
};

const hi_event_insert_button_aria_label = /** @type {(inputs: Event_Insert_Button_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट डालें`)
};

const pt_pt2_event_insert_button_aria_label = /** @type {(inputs: Event_Insert_Button_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserir evento`)
};

/**
* | output |
* | --- |
* | "Insert Event" |
*
* @param {Event_Insert_Button_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_insert_button_aria_label = /** @type {((inputs?: Event_Insert_Button_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Insert_Button_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_insert_button_aria_label(inputs)
	if (locale === "de") return de_event_insert_button_aria_label(inputs)
	if (locale === "it") return it_event_insert_button_aria_label(inputs)
	if (locale === "ru") return ru_event_insert_button_aria_label(inputs)
	if (locale === "es") return es_event_insert_button_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_event_insert_button_aria_label(inputs)
	if (locale === "ja") return ja_event_insert_button_aria_label(inputs)
	if (locale === "hi") return hi_event_insert_button_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_event_insert_button_aria_label(inputs)
	return en_event_insert_button_aria_label(inputs)
});